export default __webpack_public_path__ + "static/media/kkk1.4bd8a202.png";